import { queryOptions } from '@tanstack/react-query';
import { privateClient } from '../axiosClients/axiosClients';

export function getCostImpactOnProductsQueryOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['product-cost-impact', params],
    queryFn: () => getCostImpactOnProducts(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
export async function getCostImpactOnProducts(params) {
  try {
    if (!params.pecrId || !params.siteId) {
      return;
    }
    const response = await privateClient.get(
      '/getCostImpactOnProducts?pecrId=' +
        params.pecrId +
        '&siteId=' +
        params.siteId
    );
    return { siteId: params.siteId, data: response.data };
  } catch (error) {
    console.log('Error fetching cost impact files:', error);
  }
}

export async function updateCostImpactOnProducts(params) {
  const response = await privateClient.put('/updateCostImpactOnProducts', {
    pecrId: params.pecrId,
    siteId: params.siteId,
    costImpact: params.costImpact,
  });
  return response.data;
}

async function getECRUrl(params) {
  const response = await privateClient.get('/ECRUrl?pecrId=' + params.pecrId);
  return response.data;
}

export function createGetECRUrlOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['ecr-url', params],
    queryFn: () => getECRUrl(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

async function getValueAndEffort(params) {
  const response = await privateClient.get(
    '/valueAndEffort?pecrId=' + params.pecrId
  );
  return response.data;
}

export function createGetValueAndEffortOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['value-and-effort', params],
    queryFn: () => getValueAndEffort(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
